// src/jira/navigation-settings/types.ts
var JiraNavigationSettingsAriResourceOwner = "jira", JiraNavigationSettingsAriResourceType = "navigation-settings";

export {
  JiraNavigationSettingsAriResourceOwner,
  JiraNavigationSettingsAriResourceType
};
